import { type ReactElement } from 'react'
import { Input, Stack, Switch } from '@mantine/core'
import { type TableColumnDef } from '../types'

type ToggleColumnProps<T extends TableColumnDef> = {
  enabled: boolean
  setEnabled: (checked: boolean) => void
  column: T
}

export const ToggleColumn = <T extends TableColumnDef>({
  enabled,
  setEnabled,
  column,
}: ToggleColumnProps<T>): ReactElement => {
  return (
    <Stack gap='xs'>
      <Switch checked={enabled} label={column.label} onChange={(e) => setEnabled(e.currentTarget.checked)} />
      <Input.Description>{column.description}</Input.Description>
    </Stack>
  )
}
